export default __webpack_public_path__ + "static/media/tim-ios-activation-aa.7bca93d0.gif";